
import { useError } from '../../../../utils/context/ErrorContext';
import AddButtonWithArrow from '../../../firstTimeUserExperience/commonCom/AddButtonWithArrow';
import AddTraspButton from '../../../firstTimeUserExperience/commonCom/AddTraspButton';
import { useEffect, useState } from 'react';
import DisplayNamewithLeftBorder from '../../../common/DisplayNamewithLeftBorder';
import AddressAutocomplete from '../../../firstTimeUserExperience/commonCom/AddressAutocomplete';
import CustomInputs from '../../../common/Inputs';
import Uploader from '../../../common/CustomUploader/Uploader';
import { DocumentEntityTypesEnum, DocumentTypesEnum } from '@propertelligent/client-api';
import { UserLoginData } from '../../../common/charts/Enums';

const BasicDetailsForm = ({
    mainImage, setMainImage,
    formDetails, handleChange, isUploader = false, submitHandler = undefined,
    setShowModal, propertyValue, setPropertyvalue, values, setValues, setFileName,
    documentId, setDocumentId, fetchData
}) => {
    const { errors, errorMessages, setErrors } = useError()
    const [progress, setProgress] = useState(0);

    const organizationId = Number(sessionStorage.getItem(UserLoginData.organization_id));

    useEffect(() => {
        if (propertyValue?.address) {
            setValues({
                ...values,
                streetAddress: propertyValue?.address?.streetAddress,
                city: propertyValue?.address?.city,
                state: propertyValue?.address?.state,
                zip: propertyValue?.address?.zip
            })
            setErrors(({ ...errors, streetAddress: false, state: false, city: false, billingZipCode: false }));
        }
    }, [propertyValue])

    return (
        <>
            <form onSubmit={submitHandler} className='edit_basic_details'>
                <div className='basic_details_section px-3 pb-5'>
                    {isUploader &&
                        <div className="paymentinputrow pb-3 flex-column gap-2">
                            <div className="addressUploader">
                                <div className="uploader clickable" style={{ flexDirection: "row" }}>
                                    <Uploader
                                        name="Add Logo"
                                        setMainImage={setMainImage}
                                        mainImage={mainImage}
                                        setFileName={setFileName}
                                        progress={progress}
                                        setProgress={setProgress}
                                        Size={{
                                            size: "Icon80",
                                            iconSize: "Icon11",
                                            pSize: 30,
                                            uploadimage: "iconstyle10",
                                        }}
                                        documentId={documentId}
                                        setDocumentId={setDocumentId}
                                        EntityTypeId={DocumentEntityTypesEnum.Organization}
                                        EntityId={organizationId}
                                        DocumentTypeId={DocumentTypesEnum.Logo}
                                        organization={true}
                                        className="UploaderColumn"
                                        containerClassName="UploaderTextRow"
                                        isFatchData={fetchData}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    <div className="d-flex addContractorInputContainer1">
                        {formDetails?.basicDetails && formDetails?.basicDetails.map((item, index) => {
                            if (item.name === "phoneNumber" && formDetails?.basicDetails[index + 1]?.name === "email") {
                                return (
                                    <div className="form-row w-100" key={index}>
                                        <CustomInputs
                                            labelText={item.label}
                                            name={item.name}
                                            value={item.value}
                                            onChange={handleChange}
                                            onBlur={item.blurFunction}
                                            placeholder={item.placeholder}
                                            isError={item.isError}
                                            disabled={item.disabled}
                                            isFormControl={true}
                                            myClassName="normal_text grey_subtext1"
                                            type={item.type}
                                            maxLength={item.maxLength}
                                            required={item.required}
                                            width={item.width}
                                            errorMessages={item.errorMessages}
                                        />
                                        <CustomInputs
                                            labelText={formDetails?.basicDetails[index + 1].label}
                                            placeholder={formDetails?.basicDetails[index + 1].placeholder}
                                            value={formDetails?.basicDetails[index + 1].value}
                                            name={formDetails?.basicDetails[index + 1].name}
                                            onChange={handleChange}
                                            onBlur={formDetails?.basicDetails[index + 1].blurFunction}
                                            errorMessages={formDetails?.basicDetails[index + 1].errorMessages}
                                            isError={formDetails?.basicDetails[index + 1].isError}
                                            type={formDetails?.basicDetails[index + 1].type}
                                            required={formDetails?.basicDetails[index + 1].required}
                                            maxLength={formDetails?.basicDetails[index + 1].maxLength}
                                            width={"204px"}
                                        />
                                    </div>
                                )
                            }
                            if (item.name === "email" && formDetails?.basicDetails[index - 1]?.name === "phoneNumber") {
                                return null;
                            }
                            return (
                                <CustomInputs
                                    key={item.label}
                                    labelText={item.label}
                                    placeholder={item.placeholder}
                                    value={item.value}
                                    name={item.name}
                                    onChange={handleChange}
                                    onBlur={item.blurFunction}
                                    errorMessages={item.errorMessages}
                                    isError={item.isError}
                                    linkWebsite={item.linkWebsite}
                                    width={item.width}
                                    type={item.type}
                                    required={item.required}
                                    maxLength={item.maxLength}
                                    containerClassName="editBasicDetailInputWrapper"
                                />
                            );
                        })}
                    </div>
                    <div className='mb-3 mt-3'>
                        <DisplayNamewithLeftBorder HeaderName="Address Details" />
                        <div className="mt-3">
                            <AddressAutocomplete
                                propertyValue={propertyValue}
                                setPropertyvalue={setPropertyvalue}
                                required={false}
                                showSelectedValue={false}
                            />
                            <div className="basicDetailsForm mt-3">
                                <div className="office-address-form">
                                    <div className="d-flex addContractorInputContainer1">
                                        {formDetails?.address?.map((item: any) => (
                                            <CustomInputs
                                                key={item.label}
                                                labelText={item.label}
                                                placeholder={item.placeholder}
                                                value={item.value}
                                                name={item.name}
                                                onChange={handleChange}
                                                onBlur={item.blurFunction}
                                                errorMessages={item.errorMessages}
                                                isError={item.isError}
                                                width={item.width}
                                                type={item.type}
                                                required={item.required}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="editFormFooterContractor">
                    <AddTraspButton
                        type="button"
                        bname="Cancel"
                        onClick={() => setShowModal(false)}
                        width="fit-content"
                    />
                    <AddButtonWithArrow
                        type="submit"
                        buttonname="Save"
                        minWidth="100px"
                    />
                </div>
            </form>
        </>
    )
}

export default BasicDetailsForm